import { MenuSvg } from '../svg/menu.svg';
import { IconPropsDeprecated } from '@umanforge/common';

export const MenuIcon = ( { className = 'w-5 h-5 text-gray-600', size, onClick }: IconPropsDeprecated ) => {
  return (
    <MenuSvg
      className={ className }
      size={ size }
      onClick={ onClick }
    />
  );
};
